import { IAccountTag } from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import { useState } from 'react';
import { IModalContext } from '../../../../../models';
import { EventLogger } from '../../../../../models/Logging';
import { baseStyleSheet } from '../../../../styles/styles';
import { Modal } from '../../../Modal';
import { RadioButton } from '../../../RadioButton';
import './styles.less';

interface IMergeTagsProps extends IModalContext<IAccountTag> {
	isOpen: boolean;
	onRequestClose: (result?: IAccountTag | null, cancel?: boolean) => void;
	className?: string;
	tags: IAccountTag[];
}

export const MergeTagsModal: React.FC<IMergeTagsProps> = ({ className, isOpen, tags, onRequestClose }) => {
	const [targetTag, setTargetTag] = useState<IAccountTag | undefined>(tags[0]);
	const [errorMessage, setErrorMessage] = useState<string | undefined>();

	const onTargetTagChanged = (tag: IAccountTag) => () => {
		setTargetTag(tag);
	};

	const onMergeButtonClicked = () => {
		if (!targetTag) {
			setErrorMessage('Please select a tag');
			return;
		}

		EventLogger.logInput('MergeTags', 'Merge', 'Click');
		onRequestClose(targetTag, false);
	};

	return (
		<Modal
			className='quick-add-entity-modal'
			isOpen={isOpen}
			onRequestClose={onRequestClose}
			shouldCloseOnOverlayClick={true}
			useDefaultHeader={true}
		>
			<div className={`merge-tags ${className || ''}`}>
				<div className='merge-tags-title'>Merge Tags</div>
				<div className='merge-tags-body'>
					<div>Pick the tag you&apos;d like to keep</div>
					{tags.map((tag, i) => (
						<div className='merge-tags-list-item' key={`item-${i}-${tag.id}`}>
							<RadioButton
								checked={targetTag === tag}
								id={`item-${i}-${tag.id}`}
								name='marge-tags-options'
								onChange={onTargetTagChanged(tag)}
							>
								<span className='merge-tags-tag'>{tag.name}</span>
							</RadioButton>
						</div>
					))}
				</div>
				<div className='merge-tags-footer'>
					<button
						className={`merge-tags-footer-merge-button ${css(baseStyleSheet.ctaButton)}`}
						onClick={onMergeButtonClicked}
					>
						<span>Merge</span>
					</button>
					{!!errorMessage && (
						<span className='merge-tags-footer-error-message truncate-text' title={errorMessage}>
							{errorMessage}
						</span>
					)}
				</div>
			</div>
		</Modal>
	);
};
